export default "__VITE_ASSET__5b9734b2__"